import { createContractRequest } from './helper';
export const getOffersByPolicyHolder = createContractRequest({
    source: 'data',
    route: '/contract/offers/blob/overview/search',
    method: 'get',
});
